import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GapRentalGraphic } from "@/app/GapRentals/Components/GapRentalGraphic";
import { useGlobalSupplier } from "@/app/Suppliers/Utils/useGlobalSupplier";
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { useTranslations } from "use-intl";

export function GapRentalInfoDialog() {
  const t = useTranslations("relocation.gapRentalInfo");
  const { supplier } = useGlobalSupplier();

  const subject = supplier?.name
    ? t("calloutEmailSubject", { supplier: supplier.name })
    : t("calloutEmailSubjectFallback");
  const mailto = `mailto:alex@imoova.com?subject=${encodeURIComponent(subject)}`;

  const conditions = [
    {
      title: t("conditionSameLocation"),
      description: t("conditionSameLocationDescription"),
    },
    {
      title: t("conditionDiscount"),
      description: t("conditionDiscountDescription"),
    },
    {
      title: t("conditionBranding"),
      description: t("conditionBrandingDescription"),
    },
  ];

  return (
    <BaseDialog title={t("title")} subtitle={t("subtitle")} size="xl">
      <div className="space-y-6">
        <GapRentalGraphic />

        <div>
          <h4 className="text-sm font-semibold text-gray-900">
            {t("conditionsTitle")}
          </h4>
          <ul className="mt-3 space-y-3">
            {conditions.map(({ title, description }) => (
              <li key={title} className="flex items-start gap-3">
                <CheckCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-500" />
                <div>
                  <p className="text-sm font-medium text-gray-900">{title}</p>
                  <p className="text-sm text-gray-600">{description}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex items-center gap-4 rounded-xl border border-emerald-100 bg-emerald-50 p-4">
          <img
            className="size-14 shrink-0 rounded-full object-cover shadow-sm"
            src="https://www.imoova.com/trade-partners/alex-headshot.webp"
            alt={t("calloutName")}
            width={56}
            height={56}
          />
          <div className="min-w-0 flex-1">
            <p className="text-sm text-gray-700">{t("calloutMessage")}</p>
            <p className="mt-1 text-xs text-gray-500">
              {t("calloutName")} · {t("calloutRole")}
            </p>
          </div>
          <a
            className="shrink-0 rounded-lg bg-emerald-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-emerald-700"
            href={mailto}
          >
            {t("calloutAction")}
          </a>
        </div>
      </div>
    </BaseDialog>
  );
}
